<script setup>
definePage({ meta: { ...PageMeta.Orders.service.meta, pageTitle: 'Order' } })

import { canRecord } from '@/@layouts/plugins/casl'
import { Action } from '@/@vxapp/@Enums/PHP/Auth/DataProviders/AbilityAction'
import { OrderField } from '@/@vxapp/@Enums/PHP/ServicesV2/Orders/DataProviders/OrderField'
import { useOrderStore } from '@/@vxapp/Orders/useOrderStore'
import { useEntityPageTitle } from '@/composables/useEntityPageTitle'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import OrdersServicePage from '@/views/Previews/Orders/OrdersServicePage.vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const orderStore = useOrderStore()

useEntityPageTitle({
  entityName: 'Order',
  record: () => orderStore.order,
  recordGuid: order => order.orderGUID,
  identifier: order =>
    canRecord(Action.READ, Subject.ORDERS_PREVIEW_SERVICE, order, OrderField.DB_IDENTIFIER)
      ? order.id
      : null,
})

/* ** */
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Orders.Name"
  >
    <OrdersServicePage
      :key="route.params.guid"
      :order-g-u-i-d="route.params.guid"
      :allow-changes="false"
      :read-subject="Subject.ORDERS_PREVIEW_SERVICE"
    />
  </div>
</template>
